import { useMaxItemsSize, useMediaBreakpoints } from '../../../hooks';
export const useSliderHeight = ({
  sliderHeight: sliderHeightProp,
  tickTopPosition: tickTopPositionProp,
  options
}) => {
  const tickTopPosition = useMediaBreakpoints(tickTopPositionProp);
  const sliderHeight = useMediaBreakpoints(sliderHeightProp);
  const [tickMaxHeight, measureTickHeight] = useMaxItemsSize(options);
  return {
    tickMaxHeight,
    tickTopPosition,
    sliderHeight,
    measureTickHeight
  };
};